import React from "react";
import { Button } from "@app/shared";
import { IoCheckmark, IoPerson, IoSettings, IoChevronForward, IoDocumentText, IoInformationCircle } from "react-icons/io5";
import { NavLink } from "react-router-dom";

interface FinishPurchaseProps {
    onNext: () => void;
}

export const WelcomeStep: React.FC<FinishPurchaseProps> = ({ onNext }) => {
    return (
        <div className="max-w-2xl mx-auto text-center py-12">
            <div className="mb-8">
                <div className="w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6">
                    <IoCheckmark className="w-12 h-12" />
                </div>
                <h1 className="text-3xl font-bold  mb-4">Thank You for Your Purchase!</h1>
                <p className="text-lg mb-8">Welcome to our monitoring system. We're excited to help you get started with your new device.</p>
            </div>

            <div className=" border rounded-lg p-6 mb-8">
                <div className="flex items-center justify-center mb-4">
                    <IoInformationCircle className="w-6 h-6  mr-2" />
                    <h2 className="text-lg font-semibold">Before You Begin</h2>
                </div>
                <p className="mb-4">You will need the following information to complete the setup of your devices:</p>
                <ul className="text-left space-y-2 max-w-md">
                    <li className="flex items-start gap-2">
                        <span className=" mt-1">•</span>
                        <span>Serial Number for each Device to be installed</span>
                    </li>
                    <li className="flex items-start gap-2">
                        <span className=" mt-1">•</span>
                        <span>Physical address or GPS coordinates of where the Device(s) will be located</span>
                    </li>
                </ul>

                <div className="w-full flex justify-center">
                    <NavLink to="https://hubs.ly/Q03qFVXm0" target="_blank" className="mt-4 inline-flex items-center gap-2 px-6 py-3 rounded-xl transition-all duration-200 font-medium shadow-md hover:shadow-lg transform hover:-translate-y-0.5">
                        <IoDocumentText className="w-4 h-4" />
                        View Setup Guide
                    </NavLink>
                </div>
            </div>

            <div className="bg-white p-6 mb-8">
                <h2 className="text-xl font-semibold mb-6 text-center">What's Next?</h2>
                <div className="grid gap-4 md:grid-cols-3">
                    <div className="rounded-lg shadow-lg p-4 text-center border">
                        <div className="w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-3">
                            <IoPerson className="w-6 h-6 text-white" />
                        </div>
                        <h3 className="font-semibold mb-2">Account Setup</h3>
                        <p className="text-sm">Create your account and organization or sign in to get started</p>
                    </div>
                    <div className="rounded-lg shadow-lg p-4 text-center border">
                        <div className="w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-3">
                            <IoSettings className="w-6 h-6 text-white" />
                        </div>
                        <h3 className="font-semibold mb-2">Device Setup</h3>
                        <p className="text-sm">Configure your device settings</p>
                    </div>
                    <div className="rounded-lg shadow-lg p-4 text-center border">
                        <div className="w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-3">
                            <IoChevronForward className="w-6 h-6 text-white" />
                        </div>
                        <h3 className="font-semibold mb-2">Start Monitoring</h3>
                        <p className="text-sm">Begin using your device</p>
                    </div>
                </div>
            </div>

            <Button onClick={onNext} className="px-8 py-3 flex items-center mx-auto">
                Get Started <IoChevronForward className="w-4 h-4 ml-2" />
            </Button>
        </div>
    );
};
